// Mantine
import { Anchor } from '@mantine/core'

// Lodash
import { sortBy, groupBy } from 'lodash'

// Nextjs
// Dayjs
import dayjs from 'dayjs'

// UI
import Attachments from '../ui/Attachments'
import PurchaseOrderIncoming from './PurchaseOrderIncoming'
import SKU from '../ui/SKU'
import Box from '../ui/Box'
import Banner from '../ui/Banner'

// Classnames
import classNames from 'classnames'

export default function PurchaseOrderDisplay({
    purchaseOrder,
    openEditMode,
    refetch,
}) {
    // Group lines by reception date

    const groupedLines = sortBy(
        Object.entries(groupBy(purchaseOrder.lines, 'reception_at')).map(
            (group) => {
                // Ordered lines by component name
                const orderedLines = sortBy(group[1], [
                    (line) =>
                        line?.component?.component_category?.name_fr +
                        line.component.name,
                ])

                return [group[0], orderedLines]
            }
        ),
        [(group) => (group[0] === 'null' ? '9999-12-31' : group[0])]
    )

    return (
        <div className="w-full max-w-[1300px] mx-auto p-5 px-10 flex flex-col gap-5">
            {purchaseOrder.status === 'canceled' &&
                purchaseOrder.canceled_at && (
                    <Banner type="error" title="Bon de commande annulé">
                        Annulée le{' '}
                        {dayjs(purchaseOrder.canceled_at).format('LL à HH:mm')}
                    </Banner>
                )}

            {purchaseOrder.status === 'closed' && purchaseOrder.closed_at && (
                <Banner type="success" title="Bon de commande terminé">
                    Terminé le{' '}
                    {dayjs(purchaseOrder.closed_at).format('LL à HH:mm')}
                </Banner>
            )}

            <div className="grid grid-cols-1 2xl:grid-cols-[minmax(600px,800px)_minmax(300px,400px)] gap-5 items-start @container">
                <div className="flex flex-col gap-5 w-full">
                    <Box title="Lieu de réception">
                        <span>{purchaseOrder.location?.name}</span>
                    </Box>

                    <Box
                        className="mx-auto bg-white border rounded-sm p-10 flex flex-col w-full"
                        title={
                            'BC' +
                            purchaseOrder.id +
                            ' - ' +
                            purchaseOrder.reference
                        }
                        subtitle={
                            purchaseOrder.name +
                            ' - ' +
                            purchaseOrder.supplier?.name
                        }
                    >
                        <div className="mt-5 flex flex-col gap-5">
                            {groupedLines.map((group, index) => {
                                const receptionAt =
                                    group[0] === 'null'
                                        ? 'Non défini'
                                        : dayjs(group[0]).format('LL')

                                const lines = group[1]

                                return (
                                    <div
                                        key={index}
                                        className="flex flex-col gap-3"
                                    >
                                        <span className="font-medium">
                                            {receptionAt}
                                        </span>

                                        <div className="flex flex-col border rounded-sm">
                                            {lines.map((line) => (
                                                <div
                                                    key={line.id}
                                                    className="w-full flex justify-between items-center even:bg-gray-100 px-4 py-4"
                                                >
                                                    <div className="flex flex-col w-full gap-2">
                                                        <div className="flex items-center gap-2">
                                                            <Anchor
                                                                href={`/components/${line.component.id}`}
                                                            >
                                                                {
                                                                    line
                                                                        .component
                                                                        .component_category
                                                                        .name_fr
                                                                }
                                                                {' — '}
                                                                {
                                                                    line
                                                                        .component
                                                                        .name
                                                                }
                                                            </Anchor>
                                                        </div>

                                                        <div className="flex text-right text-sm items-center justify-between gap-2 text-gray-400">
                                                            <div>
                                                                <span
                                                                    className={classNames(
                                                                        {
                                                                            'text-green-500':
                                                                                line.quantity_received >=
                                                                                line.quantity_to_receive,
                                                                            'text-orange-500':
                                                                                line.quantity_received >
                                                                                    0 &&
                                                                                line.quantity_received <
                                                                                    line.quantity_to_receive,
                                                                        }
                                                                    )}
                                                                >
                                                                    {
                                                                        line.quantity_received
                                                                    }{' '}
                                                                    réceptionnés
                                                                    sur{' '}
                                                                    {
                                                                        line.quantity_to_receive
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex items-center gap-2">
                                                        <SKU
                                                            size="sm"
                                                            component={
                                                                line.component
                                                            }
                                                        />

                                                        <PurchaseOrderIncoming
                                                            line={line}
                                                            refetch={refetch}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </Box>
                </div>

                <div className="flex flex-col gap-5">
                    <Attachments
                        model_id={purchaseOrder.id}
                        model_type="purchase_order"
                        attachments={purchaseOrder.attachments}
                        refetchModelData={refetch}
                    />
                </div>
            </div>
        </div>
    )
}
